let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6vTNm")).then(() => parcelRequire('8Ip33'));